module.exports = __webpack_public_path__ + "8bf861b6921a2d06fb28b8d62f6631bd.jpg";